enum BotTemplate {
  Blank = 'blank',
  Basic = 'basic',
  LeadCollector = 'lead_collector',
  Quiz = 'quiz',
}

export default BotTemplate;
